<template>
  <section>
    <left-menu />

    <modalnfo-team :showType="showType"/>

    <div id="mainContent" class="my-team-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Minha Equipe</h1>
        </div>

        <div v-if="!failRequestTeamInfo" class="col-xs-12 col-sm-12 col-md-12 padding-null">
          <!-- Colaboradores Trabalhando -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box working">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Trabalhando</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-play"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.working}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(1)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Pausa -->
          <div v-if="showPause" class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box mini-box-in-pause">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Em Pausa</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-clock-o"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.totalInPause}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(2)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Atrasados -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box lates">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Atrasados</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-clock-o"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.late}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(3)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Em intervalo -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box output">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>INTERVALO/SAÍDA</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-pause"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.interval}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(4)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Sem presença -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box no-presence">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Sem presença</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-pause"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.noWorking}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(5)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Folga/D.S.R -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box no-presence">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Folga/D.S.R</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-pause"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.dayOff}}</p>
                    <p>Hoje</p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(6)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Solicitações -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box lasted-request">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Solicitações</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.totalPending}}</p>
                    <p>Últimos 30 dias</p>
                  </div>
                </div>

                <div class="view">
                  <a v-bind:href="'/lista-de-solicitacao'" target="_blank">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
          <!-- Afastamento -->
          <div class="col-xs-12 col-sm-6 col-md-3 offset-top-30">
            <div class="mini-box absence">
              <!-- Loading -->
              <div v-if="loadingTeamInfo" class="loader-mini-box">
                <div class="spinner-box">
                  <div class="rect1"></div>
                  <div class="rect2"></div>
                  <div class="rect3"></div>
                  <div class="rect4"></div>
                  <div class="rect5"></div>
                </div>
              </div>

              <!-- Content -->
              <div v-else>
                <div class="title col-xs-12 col-sm-12 col-md-12 padding-null">
                  <small>Afastamento</small>
                </div>

                <div class="info col-xs-12 col-sm-12 col-md-12 padding-null">
                  <div class="col-xs-4 col-sm-4 col-md-4">
                    <i class="fa fa-sign-out" aria-hidden="true"></i>
                  </div>
                  <div class="col-xs-8 col-sm-8 col-md-8">
                    <p>{{dataTeamInfo.absence}}</p>
                    <p></p>
                  </div>
                </div>

                <div class="view">
                  <a v-on:click="openCard(7)">Visualizar</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
          <div class="col-xs-12 col-sm-12 col-md-12 default-box box-list-user">
            <div class="infos">
              <h2 class="certa">Lista de funcionários</h2>
              <p class="nunito txt-help" v-if="dataTeam.totalEmployee">Total de membros na equipe: {{dataTeam.totalEmployee}}</p>

              <div class="select-filter">
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-3 content">
                    <p class="nunito">Pesquise por funcionário</p>
                    <autocomplete
                      id="myAutocomplete"
                      anchor="name"
                      label="writer"
                      placeholder="Comece digitando o nome"
                      v-bind:url="urlSearchEmp"
                      v-model="userSelected"
                      :customHeaders="{Authorization: 'bearer ' + bearerAutoComplete, Contentsetting: this.contentSetting}"
                      :min="1"
                      :debounce="500"
                      :onAjaxProgress="callbackEvent"
                      :onAjaxLoaded="callbackEvent"
                      :on-select="getDataSelected">
                    </autocomplete>
                    <i v-if="isSearchWithUser" v-on:click="reloadEmployers()" class="fa fa-times remove-user-icon" aria-hidden="true"></i>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 content">
                    <p class="nunito">Pesquise por Equipe</p>
                    <select v-model="selectedTeam">
                      <option value="">Todas</option>
                      <option v-for="team in listTeam" v-bind:value="team.id">
                        {{ team.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-3 content">
                    <button v-on:click="searchDataEmployers()" class="certa" type="submit">Pesquisar</button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Loading -->
            <div v-if="loading" class="loader-page-content">
              <div class="spinner">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>

            <div v-if="listEmployers.length" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-30">
              <div class="table-responsive table-clean">
                <table class="table">
                  <thead>
                  <tr>
                    <th class="certa">Funcionário</th>
                    <th class="certa">Equipe</th>
                    <th class="certa">Situação atual</th>
                    <th class="certa">Ação</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="u in listEmployers">
                    <td class="content-photo-and-infos">
                      <div class="photo">
                        <p v-if="!u.photo">{{u.name | formatName}}</p>
                        <img v-bind:src="u.photo" v-if="u.photo" alt="photo" />
                      </div>
                      <a class="no-link">
                        <span>#{{u.code}}</span>
                        <span v-bind:title="u.name">{{u.name}}</span>
                      </a>
                      <p v-bind:title="u.email" class="office">{{u.email}}</p>
                    </td>
                    <td>
                      <p class="nunito">{{u.teamName}}</p>
                    </td>
                    <td>
                      <p v-if="u.inPause" class="status-pause nunito">Em Pausa</p>
                      <p v-if="u.actualStatus" v-bind:class="{
                        'status-work': u.actualStatus === 'Trabalhando',
                        'status-interval': u.actualStatus === 'Intervalo/Saida',
                        'status-done': u.actualStatus === 'Concluído',
                        'status-incorrect': u.actualStatus === 'Ocorrência',
                        'status-fault': u.actualStatus === 'Falta'
                      }" class="nunito">{{u.actualStatus}}</p>
                      <p v-else class="status-default nunito">Sem Registro</p>
                    </td>
                    <td>
                      <a v-bind:href="'/perfil/2/' + u.id" target="_blank" class="link link-0 nunito">Visualizar Perfil</a>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <mugen-scroll :handler="getMoreEmployers" :should-handle="!loadingMoreEmployer">
                <!-- Loading -->
                <div v-if="loadingMoreEmployer" class="loader-page-content">
                  <div class="spinner-mugen">
                    <div class="rect1"></div>
                    <div class="rect2"></div>
                    <div class="rect3"></div>
                    <div class="rect4"></div>
                    <div class="rect5"></div>
                  </div>
                </div>
              </mugen-scroll>
            </div>

            <div v-if="!loading && !listEmployers.length && !loadingMoreEmployer && !isSearch && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">Nenhum funcionário encontrado.</p>
            </div>

            <div v-if="!loading && !listEmployers.length && !loadingMoreEmployer && !isSearch && failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">Tivemos um problema com a conexão. Tente novamente atualizando a página.</p>
            </div>

            <div v-if="!loading && !listEmployers.length && !loadingMoreEmployer && isSearch && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty">
              <p class="nunito">Nenhum funcionário encontrado na pesquisa.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import modalnfoTeam from '../../modals/modalnfoTeam.vue';
  import loadingTable from "../../components/loadingTable";

  import swal from 'sweetalert';
  import Autocomplete from 'vue2-autocomplete-js'
  import MugenScroll from 'vue-mugen-scroll'

  import { CHECK_TEAM, MY_TEAM_INFO, SEARCH_EMPLY, GET_USER_TEAM } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: "my-team",
    components: {
      vueFooter,
      leftMenu,
      loadingTable,
      modalnfoTeam,
      Autocomplete,
      MugenScroll
    },
    data() {
      return {
        listTeam: [],
        selectedTeam: '',
        showPause: JSON.parse(window.localStorage.getItem('userInfo')).company.isUsingPause,
        contentSetting: JSON.parse(window.localStorage.getItem('authUser')).userContentSetting,
        pageNumber: 1,
        itemsPerPage: 25,
        failRequest: false,
        failRequestTeamInfo: false,
        loading: false,
        loadingTable: false,
        loadingTeamInfo: false,
        loadingMoreEmployer: false,
        haveMoreEmployer: true,
        isSearch: false,
        isSearchWithUser: false,
        userSelected: '',
        urlSearchEmp: SEARCH_EMPLY,
        bearerAutoComplete: JSON.parse(window.localStorage.getItem('authUser')).userToken,
        dataTeamInfo: {},
        dataTeam: {
          users: {}
        },
        listEmployers: [],
        viewMoreCard: '',
        showType: ''
      }
    },
    methods: {
      callbackEvent(value) {

      },
      getMoreEmployers() {
        if (this.listEmployers.length && this.haveMoreEmployer) {
          this.loadingMoreEmployer = true;
          this.pageNumber++;
          this.checkTeam();
        }
      },
      getDataSelected(obj){
        if (obj.name && obj.id) {
          this.userSelected = obj;
          this.isSearchWithUser = true;
        }
      },
      searchDataEmployers() {
        this.isSearch = true;
        this.haveMoreEmployer = true;
        this.pageNumber = 1;
        this.listEmployers = [];
        this.loading = true;

        this.checkTeam();
      },
      reloadEmployers() {
        $('#myAutocomplete').val('');
        this.userSelected = '';
        this.isSearchWithUser = false;
      },
      openCard(val) {
        this.showType = val;
        $("#infoTeamModal").modal();
      },
      openInfo() {
        swal({
          title: "Minha Equipe",
          text: "Métrica relacionada as equipe qual você é responsável.\n Total: Total de colaboradores na equipe.\nTrabalhando: Colaboradores que bateram ponto no dia até o momento.\nSem registro: Nenhum ponto batido até o momento no dia.",
        });
      },
      checkTeam() {
        this.failRequest = false;

        let url = CHECK_TEAM;
        url += "?pageQtd=" + this.itemsPerPage;
        url += "&pageNumber=" + this.pageNumber;

        if (this.userSelected.id) {
          url += "&u=" + this.userSelected.id;
        }

        if (this.selectedTeam) {
          url += "&teamId=" + this.selectedTeam;
        }

        UTIL_SERVICE.console("URL:", url);
        REQUEST_SERVICE.get(url).then((response) => {
            UTIL_SERVICE.console("RESULT CHECK_TEAM:", response.data);

            this.dataTeam = response.data;
            if (response.data.users.length) {
              response.data.users.map((value, index) => {
                this.listEmployers.push(value);
              });

              if (response.data.users.length < 25)
                this.haveMoreEmployer = false;

            } else {
              this.haveMoreEmployer = false;
            }

            this.loading = false;
            this.loadingMoreEmployer = false;
            this.loadingTable = false;
          }).catch(reason => {
          this.failRequest = true;
          this.loadingTable = false;
          this.loading = false;
          this.loadingMoreEmployer = false;
        });
      },
      myTeamInfo() {
        this.loadingTeamInfo = true;
        this.failRequestTeamInfo = false;
        REQUEST_SERVICE.get(MY_TEAM_INFO).then((response) => {
            UTIL_SERVICE.console("RESULT MY_TEAM_INFO:", response.data);

            this.dataTeamInfo = response.data;
            this.loadingTeamInfo = false;
          }).catch(reason => {
          this.failRequestTeamInfo = true;
          this.loadingTeamInfo = false;
        });
      },
      getMyTeam() {
        REQUEST_SERVICE.get(GET_USER_TEAM + JSON.parse(window.localStorage.getItem('userInfo')).companyId).then((response) => {
          UTIL_SERVICE.console("RESULT GET_USER_TEAM:", response.data);

          this.listTeam = response.data;
        }).catch(reason => {
        });
      }
    },
    beforeMount() {
      this.loading = true;
      this.myTeamInfo();
      this.checkTeam();
      this.getMyTeam();
    }
  }
</script>

<style lang="scss">
.content-photo-and-infos {
  white-space: nowrap;
  height: 70px;
  position: relative;
  top: 2px;

  .photo {
    width: 48px;
    height: 48px;
    background: var(--bodyColor);
    border-radius: 100%;
    position: absolute;
    margin-top: 1px;

    img {
      width: 48px !important;
      height: 48px !important;
      position: absolute;
      border-radius: 100%;
      top: 0 !important;
      left: 0;
      object-fit: cover;
    }

    p {
      text-align: center;
      line-height: 48px;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 18px;
      font-family: "Montserrat", sans-serif;;
      margin: 0 !important;
    }
  }

  .no-link {
    margin-left: 58px;
    font-family: "Montserrat", sans-serif;;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: var(--titleBox);
    display: inline-block;
    cursor: default;
    margin-top: 4px;
    margin-bottom: 1px;
    min-height: 21px;

    &:hover {
      text-decoration: none;
      color: var(--titleBox) !important;
    }

    span {
      margin-right: 4px;
    }
  }

  .office {
    padding-left: 58px;
    font-size: 12px;
    margin: 0;
    margin-top: 0 !important;
  }
}

.link-0 {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/myTeam/MyTeam.vue